export const PDF_ACTION_TXT: Record<string, Record<string, string>> = {
  button: {
    wait: "Creating PDF",
    download: "Download PDF",
    make: "Create PDF",
    error: "Create PDF"
  },
  message: {
    downloading: "Downloading summary PDF...",
    making: "Exporting summary to PDF...",
    error: "Error exporting summary to PDF..."
  }
};
